import MenuItem from './menuitem';

export default class Menu {
    items: Array<MenuItem>

    constructor (items: Array<any>) {
        this.items = items.map(i => new MenuItem(i));
    }
}